webpackJsonp([10,8],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(232);
	
	var _App = __webpack_require__(579);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(210);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(148);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vuexRouterSync = __webpack_require__(586);
	
	__webpack_require__(209);
	
	__webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	_router2.default.start(_App2.default, '#app');

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var setBrowserIE = exports.setBrowserIE = function setBrowserIE(_ref, isIE) {
	  var dispatch = _ref.dispatch;
	  return dispatch('SET_BROWSER_IE', isIE);
	};
	var setBrowserSafari = exports.setBrowserSafari = function setBrowserSafari(_ref2, isSafari) {
	  var dispatch = _ref2.dispatch;
	  return dispatch('SET_BROWSER_SAFARI', isSafari);
	};
	
	var setMobileSize = exports.setMobileSize = function setMobileSize(_ref3, isMobileSize) {
	  var dispatch = _ref3.dispatch;
	  return dispatch('SET_MOBILE_SIZE', isMobileSize);
	};
	var setMobileAgent = exports.setMobileAgent = function setMobileAgent(_ref4, isMobileAgent) {
	  var dispatch = _ref4.dispatch;
	  return dispatch('SET_MOBILE_AGENT', isMobileAgent);
	};
	
	var enableGlobalOverlay = exports.enableGlobalOverlay = function enableGlobalOverlay(_ref5) {
	  var dispatch = _ref5.dispatch;
	  return dispatch('ENABLE_GLOBAL_OVERLAY');
	};
	var disableGlobalOverlay = exports.disableGlobalOverlay = function disableGlobalOverlay(_ref6) {
	  var dispatch = _ref6.dispatch;
	  return dispatch('DISABLE_GLOBAL_OVERLAY');
	};
	
	var playEnvironmentSound = exports.playEnvironmentSound = function playEnvironmentSound(_ref7) {
	  var dispatch = _ref7.dispatch;
	  return dispatch('PLAY_ENV_SOUND');
	};
	var stopEnvironmentSound = exports.stopEnvironmentSound = function stopEnvironmentSound(_ref8) {
	  var dispatch = _ref8.dispatch;
	  return dispatch('STOP_ENV_SOUND');
	};
	var setSoundSupported = exports.setSoundSupported = function setSoundSupported(_ref9, isSupported) {
	  var dispatch = _ref9.dispatch;
	  return dispatch('SET_SOUND_SUPPORTED', isSupported);
	};
	
	var openNavMenu = exports.openNavMenu = function openNavMenu(_ref10) {
	  var dispatch = _ref10.dispatch;
	  return dispatch('OPEN_NAV_MENU');
	};
	var closeNavMenu = exports.closeNavMenu = function closeNavMenu(_ref11) {
	  var dispatch = _ref11.dispatch;
	  return dispatch('CLOSE_NAV_MENU');
	};
	var openNavMenuDelay = exports.openNavMenuDelay = function openNavMenuDelay(_ref12) {
	  var dispatch = _ref12.dispatch;
	  return dispatch('OPEN_NAV_MENU_DELAY');
	};
	var closeNavMenuDelay = exports.closeNavMenuDelay = function closeNavMenuDelay(_ref13) {
	  var dispatch = _ref13.dispatch;
	  return dispatch('CLOSE_NAV_MENU_DELAY');
	};
	
	var openHotspotPanel = exports.openHotspotPanel = function openHotspotPanel(_ref14, hotspot, hotspotsContent) {
	  var dispatch = _ref14.dispatch;
	  return dispatch('OPEN_HOTSPOT_PANEL', hotspot, hotspotsContent);
	};
	var closeHotspotPanel = exports.closeHotspotPanel = function closeHotspotPanel(_ref15) {
	  var dispatch = _ref15.dispatch;
	  return dispatch('CLOSE_HOTSPOT_PANEL');
	};
	
	var openFullscreenVideo = exports.openFullscreenVideo = function openFullscreenVideo(_ref16, youtubeId, useDefaultPreloader) {
	  var dispatch = _ref16.dispatch;
	  return dispatch('OPEN_FULLSCREEN_VIDEO', youtubeId, useDefaultPreloader);
	};
	var setFullScreenVideoReady = exports.setFullScreenVideoReady = function setFullScreenVideoReady(_ref17) {
	  var dispatch = _ref17.dispatch;
	  return dispatch('SET_FULLSCREEN_VIDEO_READY');
	};
	var closeFullscreenVideo = exports.closeFullscreenVideo = function closeFullscreenVideo(_ref18) {
	  var dispatch = _ref18.dispatch;
	  return dispatch('CLOSE_FULLSCREEN_VIDEO');
	};

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(236);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(233);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _knot = __webpack_require__(514);
	
	var _knot2 = _interopRequireDefault(_knot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    var settings = {
	        container: options.container || 'body',
	
	        steps: options.steps,
	        initial: options.initial || 1,
	
	        rows: options.rows || 1,
	        width: options.width,
	        height: options.height,
	
	        flip: options.flip || false,
	        displayMode: options.displayMode || 'fluid',
	        breakpoint: options.breakpoint || 640,
	
	        src: options.src,
	        mask: options.mask || false,
	        proxy: options.proxy || false,
	
	        ariaLabel: options.ariaLabel || ''
	    };
	
	    var imageNode = null;
	    var mainNode = null;
	    var svgNode = null;
	    var proxyNode = null;
	    var fallbackNode = null;
	
	    var proxyImagesList = [];
	    var proxyTimeout = null;
	    var backgroundSize = null;
	    var sprite = {
	        columns: null,
	        width: null,
	        height: null,
	        ratio: null
	    };
	    var currentStep = settings.initial;
	    var frameRequest = null;
	
	    var isAnimationPlaying = false;
	    var elapsedSteps = 0;
	
	    var __build = [_calculations, _generateMain, _generateSVG, _generateProxy, _accessibility, _bindEvents, _generateCSS, flip, _defaultStep];
	
	    var __init = [load, build];
	
	    var __refresh = [_generateCSS, flip, _defaultStep];
	
	    var instance = (0, _knot2.default)({
	        init: init,
	        load: load,
	        build: build,
	        refresh: refresh,
	        destroy: destroy,
	        changeStep: changeStep,
	        changeProgress: changeProgress,
	        play: play,
	        pause: pause,
	        stop: stop,
	        getCurrentStep: getCurrentStep,
	        isMaskingSupported: isMaskingSupported,
	        flip: flip
	    });
	
	    return instance;
	
	    function __runSeries(functions) {
	        return new _promise2.default(function (resolve, reject) {
	            resolve(functions.forEach(function (func) {
	                return func();
	            }));
	        });
	    }
	
	    function __camelize(str) {
	        return str.replace(/(\-[a-z])/g, function ($1) {
	            return $1.toUpperCase().replace('-', '');
	        });
	    }
	
	    function __prefixCss(element, property, value) {
	        var capitalizedProperty = property.charAt(0).toUpperCase() + property.slice(1);
	        element.style['webkit' + capitalizedProperty] = value;
	        element.style['moz' + capitalizedProperty] = value;
	        element.style['ms' + capitalizedProperty] = value;
	        element.style['o' + capitalizedProperty] = value;
	        element.style[property] = value;
	    }
	
	    function __setAttributes(element, attributes) {
	        if (element !== null) {
	            for (var attribute in attributes) {
	                element.setAttribute(attribute, attributes[attribute]);
	            }
	        }
	    }
	
	    function __setCss(element, rules) {
	        if (element !== null) {
	            for (var rule in rules) {
	                if (rule === 'transform') {
	                    __prefixCss(element, 'transform', rules[rule]);
	                } else {
	                    element.style[__camelize(rule)] = rules[rule];
	                }
	            }
	        }
	    }
	
	    function __css(elements, rules) {
	        if (elements !== null && elements.constructor === Array) {
	            for (var i = 0; i < elements.length; i++) {
	                __setCss(elements[i], rules);
	            }
	        } else {
	            __setCss(elements, rules);
	        }
	    }
	
	    function _calculations() {
	        sprite.columns = Math.ceil(settings.steps / settings.rows);
	
	        backgroundSize = 100 * sprite.columns;
	
	        sprite.width = settings.width / sprite.columns;
	        sprite.width = (Math.round(sprite.width * 1000 / 10) / 100).toFixed(2);
	
	        sprite.height = settings.height / settings.rows;
	        sprite.height = (Math.round(sprite.height * 1000 / 10) / 100).toFixed(2);
	
	        sprite.ratio = sprite.width / sprite.height;
	    }
	
	    function _generateMain() {
	        if (mainNode === null) {
	            mainNode = document.createElement('div');
	            fallbackNode = document.createElement('div');
	            mainNode.appendChild(fallbackNode);
	
	            if ((0, _typeof3.default)(settings.container) === 'object') {
	                settings.container.appendChild(mainNode);
	            } else {
	                document.querySelector(settings.container).appendChild(mainNode);
	            }
	        }
	    }
	
	    function _bindEvents() {
	        window.addEventListener('resize', _viewportResize);
	    }
	
	    function _unbindEvents() {
	        window.removeEventListener('resize', _viewportResize);
	    }
	
	    function _viewportResize() {
	        return refresh();
	    }
	
	    function _accessibility() {
	        if (settings.ariaLabel.length > 2) {
	            __setAttributes(mainNode, {
	                'role': 'img',
	                'aria-label': settings.ariaLabel,
	                'tabindex': '0',
	                'aria-hidden': 'false'
	            });
	        } else {
	            __setAttributes(mainNode, {
	                'role': 'img',
	                'aria-hidden': 'false'
	            });
	        }
	    }
	
	    function _generateProxy() {
	        if (proxyNode === null) {
	            proxyNode = document.createElement('div');
	            mainNode.appendChild(proxyNode);
	        }
	    }
	
	    function _generateSVG() {
	        if (_canUseSVG() && settings.mask !== false && svgNode === null) {
	            svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	            svgNode.innerHTML = '<defs>\n                    <mask id="spritzTopMask">\n                        <image width="' + settings.width + '" height="' + settings.height + '" xlink:href="' + settings.mask + '"></image>\n                    </mask>\n                </defs>\n                <image mask="url(#spritzTopMask)" id="spritzTop" width="' + settings.width + '" height="' + settings.height + '" xlink:href="' + settings.src + '"></image> ';
	            __setAttributes(svgNode, {
	                'preserveAspectRatio': 'xMinYMin',
	                'width': '100%',
	                'height': '100%',
	                'version': '1.1',
	                'xmlns:xlink': 'http://www.w3.org/1999/xlink',
	                'viewBox': '0 0 ' + sprite.width + ' ' + sprite.height + ''
	            });
	            mainNode.appendChild(svgNode);
	        }
	    }
	
	    function _canUseSVG() {
	        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true) {
	            return false;
	        }
	
	        return !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect);
	    }
	
	    function _defaultStep() {
	        changeStep(settings.initial, true);
	    }
	
	    function _generateCSS() {
	        __css(mainNode, {
	            'overflow': 'hidden',
	            'outline': '0'
	        });
	        __css(fallbackNode, {
	            'position': 'absolute',
	            'top': '0',
	            'left': '0',
	            'width': '100%',
	            'height': '100%',
	            'background-size': '' + backgroundSize + '%',
	            'background-position': '0 0',
	            'background-repeat': 'no-repeat'
	        });
	        __css(svgNode, {
	            'position': 'absolute',
	            'top': '0',
	            'left': '0',
	            'opacity': '1'
	        });
	        __css(proxyNode, {
	            'position': 'absolute',
	            'left': '-9999px',
	            'top': '0',
	            'width': '100%',
	            'height': '100%',
	            'opacity': '0',
	            'background-repeat': 'no-repeat',
	            'background-size': '100%',
	            'background-position': '0 0'
	        });
	
	        if (settings.displayMode === 'fluid') {
	            __css(mainNode, {
	                'position': 'relative',
	                'width': '100%',
	                'height': '' + mainNode.parentNode.clientWidth / sprite.ratio + 'px'
	            });
	        } else {
	            __css(mainNode, {
	                'position': 'absolute',
	                'left': '50%',
	                'top': '50%',
	                'transform': 'translate(-50%, -50%)',
	                'width': '' + sprite.width + 'px',
	                'height': '' + sprite.height + 'px'
	            });
	        }
	        if (imageNode !== null) {
	            __css(fallbackNode, {
	                'background-image': 'url("' + imageNode.src + '")'
	            });
	        }
	        if (svgNode !== null) {
	            __css(fallbackNode, {
	                'opacity': '0'
	            });
	        }
	    }
	
	    function _showProxy() {
	        __css([svgNode, fallbackNode], {
	            'transition': 'opacity 0.6s linear 0.7s',
	            'opacity': '0'
	        });
	
	        __css(proxyNode, {
	            'transition': 'opacity 0.6s linear 0.1s',
	            'opacity': '1',
	            'left': '0'
	        });
	    }
	
	    function _hideProxy() {
	        if (svgNode !== null) {
	            __css(svgNode, {
	                'transition': 'none',
	                'opacity': '1'
	            });
	        } else {
	            __css(fallbackNode, {
	                'transition': 'none',
	                'opacity': '1'
	            });
	        }
	
	        __css(proxyNode, {
	            'transition': 'none',
	            'opacity': '0',
	            'left': '-9999px'
	        });
	    }
	
	    function _loadProxyImage(source) {
	        return new _promise2.default(function (resolve, reject) {
	            if (typeof proxyImagesList[source] === 'undefined') {
	                var proxyImage = new Image();
	                proxyImage.onload = function () {
	                    proxyImagesList[source] = proxyImage;
	                    resolve(proxyImagesList[source]);
	                };
	                proxyImage.src = source;
	            } else {
	                resolve(proxyImagesList[source]);
	            }
	        });
	    }
	
	    function _nextStep() {
	        return currentStep < settings.steps ? currentStep + 1 : 1;
	    }
	
	    function _prevStep() {
	        return currentStep > 1 ? currentStep - 1 : settings.steps;
	    }
	
	    function _proxy(step) {
	        if (typeof settings.proxy[step] === 'undefined') {
	            return;
	        }
	
	        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	        if (settings.breakpoint !== false && viewportWidth < settings.breakpoint) {
	            return;
	        }
	
	        if (proxyNode !== null) {
	            var proxySrc = settings.proxy[step];
	            _loadProxyImage(proxySrc).then(function (proxyImage) {
	                __css(proxyNode, { 'background-image': 'url("' + proxyImage.getAttribute('src') + '")' });
	                _showProxy();
	
	                setTimeout(function () {
	                    proxyNode.style.left = '0';
	                }, 100);
	            });
	        }
	    }
	
	    function _requestAnimation(interval) {
	        var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'next';
	        var lastTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        if (frameRequest !== null) {
	            window.cancelAnimationFrame(frameRequest);
	            frameRequest = null;
	        }
	
	        frameRequest = window.requestAnimationFrame(function (timestamp) {
	            _loopAnimation(interval, step, timestamp, lastTime);
	        });
	    }
	
	    function _loopAnimation(interval, step, timestamp, lastTime) {
	        var update = timestamp - lastTime >= interval;
	
	        if (update) {
	            changeStep(step);
	            lastTime = timestamp;
	        }
	
	        if (isAnimationPlaying) {
	            _requestAnimation(interval, step, lastTime);
	        }
	    }
	
	    function init() {
	        var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        if (initial !== null) settings.initial = initial;
	        __runSeries(__init).then(function () {
	            instance.emit('init');
	        });
	        return this;
	    }
	
	    function build() {
	        elapsedSteps = 0;
	        __runSeries(__build).then(function () {
	            instance.emit('build');
	        });
	        return this;
	    }
	
	    function refresh() {
	        settings.initial = currentStep;
	        __runSeries(__refresh).then(function () {
	            instance.emit('refresh');
	        });
	        return this;
	    }
	
	    function flip() {
	        var doFlip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : settings.flip;
	
	        if (doFlip === true) {
	            __css([fallbackNode, proxyNode, svgNode], {
	                'transform': 'scaleX(-1)',
	                'filter': 'fliph()',
	                '-ms-filter': 'FlipH'
	            });
	        } else {
	            __css([fallbackNode, proxyNode, svgNode], {
	                'transform': 'none',
	                'filter': 'none',
	                '-ms-filter': 'none'
	            });
	        }
	        return this;
	    }
	
	    function destroy() {
	        pause(true);
	        _unbindEvents();
	
	        if (mainNode !== null) {
	            mainNode.parentNode.removeChild(mainNode);
	        }
	
	        instance.emit('destroy');
	        instance.off('init');
	        instance.off('load');
	        instance.off('build');
	        instance.off('destroy');
	        instance.off('play');
	        instance.off('pause');
	        instance.off('stop');
	        instance.off('change');
	
	        imageNode = fallbackNode = mainNode = svgNode = proxyNode = proxyTimeout = null;
	        proxyImagesList = [];
	
	        return this;
	    }
	
	    function load() {
	        if (imageNode === null) {
	            imageNode = new Image();
	            imageNode.onload = function () {
	                instance.emit('load');
	            };
	            imageNode.src = settings.src;
	        }
	        return this;
	    }
	
	    function isMaskingSupported() {
	        return _canUseSVG;
	    }
	
	    function getCurrentStep() {
	        return currentStep;
	    }
	
	    function changeStep() {
	        var targetStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (mainNode != null && imageNode != null) {
	            _hideProxy();
	
	            var targetStepDecoded = targetStep === 'next' ? _nextStep() : targetStep === 'previous' ? _prevStep() : targetStep;
	
	            var stepZero = targetStepDecoded - 1;
	            var rowsZero = settings.rows - 1;
	            var columnsZero = sprite.columns - 1;
	
	            var positionX = sprite.columns > 1 ? 100 / columnsZero * (stepZero % sprite.columns) : 0;
	            var positionY = settings.rows > 1 ? 100 / rowsZero * Math.floor(stepZero / sprite.columns) : 0;
	
	            if (svgNode !== null) {
	                positionX = positionX * columnsZero / 100 * sprite.width;
	                positionY = positionY * rowsZero / 100 * sprite.height;
	
	                svgNode.setAttribute('viewBox', '' + positionX + ' ' + positionY + ' ' + sprite.width + ' ' + sprite.height + '');
	            } else {
	                fallbackNode.style.backgroundPosition = '' + positionX + '% ' + positionY + '%';
	            }
	
	            currentStep = targetStepDecoded;
	
	            if (settings.proxy !== false) {
	                clearTimeout(proxyTimeout);
	                if (frameRequest === null) {
	                    proxyTimeout = setTimeout(function () {
	                        _proxy(targetStepDecoded);
	                    }, 500);
	                }
	            }
	
	            if (silent === false) {
	                elapsedSteps++;
	                instance.emit('change', targetStepDecoded, elapsedSteps);
	            }
	        }
	        return this;
	    }
	
	    function changeProgress() {
	        var progressValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        var stepEquiv = Math.round(progressValue * 100 * settings.steps / 100);
	        return changeStep(stepEquiv === 0 ? stepEquiv + 1 : stepEquiv);
	    }
	
	    function play() {
	        var fps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
	        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'forward';
	
	        elapsedSteps = 0;
	        var interval = 1000 / fps;
	        if (fps === 0) pause();
	        isAnimationPlaying = true;
	        var _direction = direction === 'forward' ? 'next' : 'previous';
	        _requestAnimation(interval, _direction);
	        instance.emit('play');
	        return this;
	    }
	
	    function pause() {
	        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (frameRequest !== null) {
	            elapsedSteps = 0;
	            isAnimationPlaying = false;
	            window.cancelAnimationFrame(frameRequest);
	            frameRequest = null;
	            if (silent === false) instance.emit('pause');
	        }
	        return this;
	    }
	
	    function stop() {
	        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.pause(true);
	        if (silent === false) instance.emit('stop');
	        this.changeStep(settings.initial, false);
	        return this;
	    }
	};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(587);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _logger = __webpack_require__(588);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	var state = {
	    isBrowserIE: false,
	    isBrowserSafari: false,
	
	    isMobileSize: true,
	    isMobileAgent: true,
	
	    isGlobalOverlayEnabled: false,
	
	    isEnvironmentSoundPlaying: false,
	    isSoundSupported: false,
	
	    isNavMenuOpened: false,
	    isNavMenuOpenedDelay: false,
	
	    isHotspotPanelOpened: false,
	    hotspot: false,
	    totalHotspots: false,
	    hotspotNumber: false,
	    hotspotsContent: false,
	
	    isFullscreenVideoOpened: false,
	    isFullscreenVideoReady: false,
	    youtubeVideoId: false,
	    useDefaultPreloader: false
	};
	
	var mutations = {
	    SET_BROWSER_IE: function SET_BROWSER_IE(state, isIE) {
	        state.isBrowserIE = typeof isIE !== 'undefined' ? isIE : true;
	    },
	    SET_BROWSER_SAFARI: function SET_BROWSER_SAFARI(state, isSafari) {
	        state.isBrowserSafari = typeof isSafari !== 'undefined' ? isSafari : true;
	    },
	    SET_MOBILE_SIZE: function SET_MOBILE_SIZE(state, isMobileSize) {
	        state.isMobileSize = typeof isMobileSize !== 'undefined' ? isMobileSize : true;
	    },
	    SET_MOBILE_AGENT: function SET_MOBILE_AGENT(state, isMobileAgent) {
	        state.isMobileAgent = typeof isMobileAgent !== 'undefined' ? isMobileAgent : true;
	    },
	    ENABLE_GLOBAL_OVERLAY: function ENABLE_GLOBAL_OVERLAY(state) {
	        state.isGlobalOverlayEnabled = true;
	    },
	    DISABLE_GLOBAL_OVERLAY: function DISABLE_GLOBAL_OVERLAY(state) {
	        state.isGlobalOverlayEnabled = false;
	    },
	    PLAY_ENV_SOUND: function PLAY_ENV_SOUND(state) {
	        state.isEnvironmentSoundPlaying = true;
	    },
	    STOP_ENV_SOUND: function STOP_ENV_SOUND(state) {
	        state.isEnvironmentSoundPlaying = false;
	    },
	    SET_SOUND_SUPPORTED: function SET_SOUND_SUPPORTED(state, isSupported) {
	        state.isSoundSupported = typeof isSupported !== 'undefined' ? isSupported : true;
	    },
	    OPEN_NAV_MENU: function OPEN_NAV_MENU(state) {
	        state.isNavMenuOpened = true;
	    },
	    CLOSE_NAV_MENU: function CLOSE_NAV_MENU(state) {
	        state.isNavMenuOpened = false;
	    },
	    OPEN_NAV_MENU_DELAY: function OPEN_NAV_MENU_DELAY(state) {
	        state.isNavMenuOpenedDelay = true;
	    },
	    CLOSE_NAV_MENU_DELAY: function CLOSE_NAV_MENU_DELAY(state) {
	        state.isNavMenuOpenedDelay = false;
	    },
	    OPEN_HOTSPOT_PANEL: function OPEN_HOTSPOT_PANEL(state, hotspot, hotspotsContent) {
	        state.isHotspotPanelOpened = true;
	        state.hotspot = hotspot;
	
	        state.hotspotsContent = hotspotsContent;
	        state.hotspotNumber = hotspotsContent.findIndex(function (_hotspot) {
	            return _hotspot.id === hotspot.id;
	        });
	        state.totalHotspots = hotspotsContent.length;
	    },
	    CLOSE_HOTSPOT_PANEL: function CLOSE_HOTSPOT_PANEL(state) {
	        state.isHotspotPanelOpened = false;
	    },
	    OPEN_FULLSCREEN_VIDEO: function OPEN_FULLSCREEN_VIDEO(state, youtubeId, useDefaultPreloader) {
	        state.isFullscreenVideoOpened = true;
	        state.youtubeVideoId = youtubeId;
	        state.isFullscreenVideoReady = false;
	        state.useDefaultPreloader = typeof useDefaultPreloader !== 'undefined' ? useDefaultPreloader : false;
	    },
	    SET_FULLSCREEN_VIDEO_READY: function SET_FULLSCREEN_VIDEO_READY(state) {
	        state.isFullscreenVideoReady = true;
	    },
	    CLOSE_FULLSCREEN_VIDEO: function CLOSE_FULLSCREEN_VIDEO(state) {
	        state.isFullscreenVideoReady = false;
	        state.isFullscreenVideoOpened = false;
	    }
	};
	
	exports.default = new _vuex2.default.Store({
	    state: state,
	    mutations: mutations,
	    strict: debug,
	    plugins: debug ? [(0, _logger2.default)()] : []
	});

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(502)
	__vue_script__ = __webpack_require__(215)
	__vue_template__ = __webpack_require__(565)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(490)
	__vue_script__ = __webpack_require__(220)
	__vue_template__ = __webpack_require__(553)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _perfectScrollbar = __webpack_require__(147);
	
	var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);
	
	var _lodash = __webpack_require__(84);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('view-directive', {
	    params: ['routeName'],
	
	    bind: function bind() {
	        var excludedRoutes = ['home', 'about', 'view', 'graham'];
	
	        if (!excludedRoutes.includes(this.params.routeName)) {
	            var scrollyMe = this.el.querySelectorAll('.scrolly-me-container');
	            for (var i = 0; i !== scrollyMe.length; i++) {
	                _perfectScrollbar2.default.initialize(scrollyMe[i], {
	                    suppressScrollX: true
	                });
	            }
	
	            window.addEventListener('resize', (0, _lodash2.default)(function () {
	                for (var _i = 0; _i !== scrollyMe.length; _i++) {
	                    _perfectScrollbar2.default.update(scrollyMe[_i]);
	                }
	            }, 400));
	
	            setTimeout(function () {
	                var event = document.createEvent('CustomEvent');
	                event.initCustomEvent('resize', true, true, {});
	                window.dispatchEvent(event);
	            }, 400);
	        }
	
	        var isIE = this.vm.isBrowserIE;
	        if (isIE || !Modernizr.svg) {
	            var imgs = this.el.querySelectorAll('[data-fallback-src]');
	            for (var _i2 = 0; _i2 !== imgs.length; _i2++) {
	                imgs[_i2].src = imgs[_i2].getAttribute('data-fallback-src');
	                imgs[_i2].removeAttribute('data-fallback-src');
	            }
	        }
	    }
	});

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _marked = __webpack_require__(516);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('googleDirection', function (address) {
	    return 'https://google.com/maps/dir//' + address.replace(/\s\s+/g, ' ');
	});
	
	_vue2.default.filter('addZero', function (number) {
	    return number.length > 1 ? number : '0' + number;
	});
	
	_vue2.default.filter('markdown', function (content) {
	    var output = content;
	
	    output = output.replace(/!\[([a-zA-Z0-9 \-\/_.]*)[^\]]*\]\(([a-zA-Z0-9 \-\/_.]*)[^)]*\)/g, '<img src="$2" alt="$1">');
	
	    output = output.replace(/<!--column-break-->/g, '</div><div class="table-cell">');
	
	    output = output.replace(/<!--youtube:([A-Za-z0-9_\-]*)-->/g, '<div class="iframe-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/$1?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe></div>');
	
	    output = output.replace(/<author>(.*?)<\/author>/g, '<span class="quote-author">$1</span>');
	
	    return '<div class="table"><div class="table-cell md-column">' + (0, _marked2.default)(output) + '</div></div>';
	});

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(585);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	    suppressTransitionError: true,
	    transitionOnLoad: true,
	    history: true,
	    hashbang: false
	});
	
	router.map({
	    '/': {
	        name: 'home',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(583)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/view-graham': {
	        name: 'view',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(207)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/graham/:hotspot': {
	        name: 'graham',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(207)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/about-the-project': {
	        name: 'about',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/the-broader-context': {
	        name: 'context',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/education': {
	        name: 'educational',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(582)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/privacy-policy': {
	        name: 'privacy',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(584)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/accessibility': {
	        name: 'accessibility',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/disclaimer': {
	        name: 'disclaimer',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(581)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    }
	});
	
	router.beforeEach(function (transition) {
	
	    var isPreloadingDisabled = transition.from.name === 'graham' && transition.to.name === 'view' || transition.to.name === 'graham' && transition.from.name === 'view' || transition.to.name === 'graham' && transition.from.name === 'graham';
	
	    if (isPreloadingDisabled) {
	        transition.next();
	    } else {
	        router.app.$root.$emit('loading-start');
	        transition.next();
	    }
	
	    router.app.$emit('viewport-unbind', transition.from.name);
	});
	
	router.afterEach(function (transition) {
	    window.scrollTo(0, 0);
	
	    var isIE = transition.to.router.app.$store.state.isBrowserIE;
	    if (isIE || !Modernizr.svg) {
	        var imgs = router.app.$el.querySelectorAll('[data-fallback-src]');
	        for (var i = 0; i !== imgs.length; i++) {
	            imgs[i].src = imgs[i].getAttribute('data-fallback-src');
	            imgs[i].removeAttribute('data-fallback-src');
	        }
	    }
	
	    router.app.$emit('viewport-bind', transition.to.name);
	});
	
	router.redirect({
	    '*': '/'
	});
	
	exports.default = router;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Sound = __webpack_require__(206);
	
	var _Sound2 = _interopRequireDefault(_Sound);
	
	var _actions = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    vuex: {
	        getters: {
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isNavMenuOpenedDelay: function isNavMenuOpenedDelay(state) {
	                return state.isNavMenuOpenedDelay;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            }
	        },
	        actions: {
	            closeNavMenuDelay: _actions.closeNavMenuDelay,
	            closeNavMenu: _actions.closeNavMenu
	        }
	    },
	
	    ready: function ready() {
	        var _this = this;
	
	        this.$els.twitterShare.addEventListener('click', function (event) {
	            event.preventDefault();
	            var shareUrl = 'https://twitter.com/share?url=' + _this.$root.template.sharing_url + '&text=' + _this.$root.template.sharing_twitter + '&hashtags=' + _this.$root.template.sharing_hashtag + '&original_referer=' + window.location + '';
	            window.open(shareUrl, '_blank');
	        }, false);
	
	        this.$els.facebookShare.addEventListener('click', function (event) {
	            event.preventDefault();
	            var shareUrl = 'https://www.facebook.com/sharer.php?u=' + _this.$root.template.sharing_url + '';
	            window.open(shareUrl, '_blank');
	        }, false);
	    },
	
	    methods: {
	        closeNavPanel: function closeNavPanel() {
	            this.closeNavMenu();
	
	            setTimeout(function () {
	                this.closeNavMenuDelay();
	            }.bind(this), 50);
	        }
	    },
	
	    components: {
	        'sound-component': _Sound2.default
	    }
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Sound = __webpack_require__(206);
	
	var _Sound2 = _interopRequireDefault(_Sound);
	
	var _perfectScrollbar = __webpack_require__(147);
	
	var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);
	
	var _lodash = __webpack_require__(84);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hammerjs = __webpack_require__(203);
	
	var _hammerjs2 = _interopRequireDefault(_hammerjs);
	
	var _actions = __webpack_require__(15);
	
	var _HotspotsNav = __webpack_require__(205);
	
	var _HotspotsNav2 = _interopRequireDefault(_HotspotsNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    vuex: {
	        getters: {
	            isGlobalOverlayEnabled: function isGlobalOverlayEnabled(state) {
	                return state.isGlobalOverlayEnabled;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            },
	            hotspot: function hotspot(state) {
	                return state.hotspot;
	            },
	            totalHotspots: function totalHotspots(state) {
	                return state.totalHotspots;
	            },
	            hotspotNumber: function hotspotNumber(state) {
	                return state.hotspotNumber;
	            },
	            hotspotsContent: function hotspotsContent(state) {
	                return state.hotspotsContent;
	            },
	            isMobileSize: function isMobileSize(state) {
	                return state.isMobileSize;
	            },
	            isMobileAgent: function isMobileAgent(state) {
	                return state.isMobileAgent;
	            },
	            isBrowserSafari: function isBrowserSafari(state) {
	                return state.isBrowserSafari;
	            }
	        },
	        actions: {
	            enableGlobalOverlay: _actions.enableGlobalOverlay,
	            disableGlobalOverlay: _actions.disableGlobalOverlay,
	            closeHotspotPanel: _actions.closeHotspotPanel,
	            openHotspotPanel: _actions.openHotspotPanel
	        }
	    },
	
	    data: function data() {
	        return {
	            isFirstLoad: true,
	            isHotspotPanelVisible: false,
	            scrollbar: false,
	            resizeHandler: false,
	            mouseHandler: false,
	
	            xrayAreaWidth: false,
	            xrayAreaHeight: false,
	            xrayAreaOffsetLeft: false,
	            xrayAreaOffsetTop: false,
	            xrayRadius: 0,
	            xrayRadiusPx: 0,
	            xrayCX: 50,
	            xrayCY: 50,
	            xrayAnimStart: false,
	            xrayRequestAnim: false,
	            xrayEllipseIsOutside: false,
	            xrayDeltaX: 0,
	            xrayDeltaY: 0,
	
	            enableXrayInteraction: true
	        };
	    },
	
	    methods: {
	
	        'xrayResetAnim': function xrayResetAnim(timestamp) {
	            if (!this.xrayAnimStart) this.xrayAnimStart = timestamp;
	            var progress = timestamp - this.xrayAnimStart;
	
	            if (progress < 2000) {
	                if (this.xrayRequestAnim !== false) {
	                    this.xrayRequestAnim = window.requestAnimationFrame(this.xrayResetAnim);
	                }
	            } else {
	                if (this.$els.xrayCxResetAnim !== null && 'beginElement' in this.$els.xrayCxResetAnim && !this.isBrowserSafari) {
	                    this.$els.xrayCxResetAnim.beginElement();
	                    this.$els.xrayCyResetAnim.beginElement();
	                } else {
	                    this.xrayMove();
	                }
	                this.xrayRequestAnim = false;
	            }
	        },
	
	        'xrayCancelResetAnim': function xrayCancelResetAnim() {
	            if (this.xrayRequestAnim !== false) {
	                window.cancelAnimationFrame(this.xrayRequestAnim);
	            }
	            this.$set('xrayRequestAnim', false);
	            this.$set('xrayAnimStart', false);
	        },
	
	        'xrayBeginResetAnim': function xrayBeginResetAnim() {
	            this.xrayCancelResetAnim();
	            this.xrayRequestAnim = window.requestAnimationFrame(this.xrayResetAnim);
	        },
	
	        'getCX': function getCX(mouseX) {
	            return ((mouseX - this.xrayAreaOffsetLeft) / this.xrayAreaWidth * 100).toFixed(2);
	        },
	
	        'getCY': function getCY(mouseY) {
	            return ((mouseY - this.xrayAreaOffsetTop) / this.xrayAreaHeight * 100).toFixed(2);
	        },
	
	        'xrayMove': function xrayMove() {
	            var mouseX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var mouseY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            if (this.$els.xrayArea !== null) {
	                if (!this.isMobileSize && mouseX !== false && mouseY !== false) {
	                    var hitLeftLimit = mouseX - this.xrayRadiusPx < this.xrayAreaOffsetLeft;
	                    var hitRightLimit = mouseX + this.xrayRadiusPx > this.xrayAreaOffsetLeft + this.xrayAreaWidth;
	                    var hitTopLimit = mouseY - this.xrayRadiusPx < this.xrayAreaOffsetTop;
	                    var hitBottomLimit = mouseY + this.xrayRadiusPx > this.xrayAreaOffsetTop + this.xrayAreaHeight;
	
	                    var cx = this.getCX(mouseX);
	                    var cy = this.getCY(mouseY);
	                    this.$set('xrayCX', cx);
	                    this.$set('xrayCY', cy);
	
	                    if (hitLeftLimit) {
	                        this.$set('xrayCX', this.getCX(this.xrayRadiusPx));
	                    }
	                    if (hitRightLimit) {
	                        this.$set('xrayCX', this.getCX(this.xrayAreaWidth - this.xrayRadiusPx));
	                    }
	                    if (hitTopLimit) {
	                        this.$set('xrayCY', this.getCY(this.xrayRadiusPx));
	                    }
	                    if (hitBottomLimit) {
	                        this.$set('xrayCY', this.getCY(this.xrayAreaHeight - this.xrayRadiusPx));
	                    }
	
	                    var isOutside = hitLeftLimit || hitRightLimit || hitTopLimit || hitBottomLimit;
	                    if (isOutside) {
	                        this.xrayBeginResetAnim();
	                    } else {
	                        this.xrayCancelResetAnim();
	                    }
	                } else {
	                    this.xrayCancelResetAnim();
	                    this.$set('xrayCX', 50);
	                    this.$set('xrayCY', 50);
	                }
	            }
	        },
	
	        'bindEvents': function bindEvents() {
	            this.resizeHandler = (0, _lodash2.default)(function () {
	                this.checkMobile();
	                if (this.scollbar) this.scrollbar.update(this.$els.scrollyMe);
	            }.bind(this), 500);
	            window.addEventListener('resize', this.resizeHandler, false);
	
	            this.mouseHandler = (0, _lodash2.default)(function (event) {
	                this.xrayMove(event.clientX, event.clientY);
	            }.bind(this), 5);
	            if (this.enableXrayInteraction && this.$els.xrayArea !== null) {
	                this.xrayMove();
	                this.$els.xrayArea.addEventListener('mousemove', this.mouseHandler, false);
	            }
	
	            setTimeout(function () {
	                var event = document.createEvent('CustomEvent');
	                event.initCustomEvent('resize', true, true, {});
	                window.dispatchEvent(event);
	            }, 650);
	        },
	
	        'unbindEvents': function unbindEvents() {
	            window.removeEventListener('resize', this.resizeHandler, false);
	
	            if (this.enableXrayInteraction) {
	                window.removeEventListener('mousemove', this.mouseHandler, false);
	            }
	        },
	
	        'checkMobile': function checkMobile() {
	            if (this.$els.xrayArea !== null) {
	                this.$set('xrayAreaWidth', this.$els.xrayArea.offsetWidth);
	                this.$set('xrayAreaHeight', this.$els.xrayArea.offsetHeight);
	                this.$set('xrayAreaOffsetLeft', this.$els.xrayArea.getBoundingClientRect().left);
	                this.$set('xrayAreaOffsetTop', this.$els.xrayArea.getBoundingClientRect().top);
	
	                if (this.isMobileSize) {
	                    this.$set('xrayRadius', 18);
	                } else {
	                    this.$set('xrayRadius', 15);
	                    if (this.isGlobalOverlayEnabled) {
	                        this.disableGlobalOverlay();
	                    }
	                }
	
	                this.$nextTick(function () {
	                    this.$set('xrayRadiusPx', this.$els.xrayEllipse.getBoundingClientRect().width / 2 + 5);
	
	                    if (this.isFirstLoad) {
	                        if (!this.isMobileSize && this.isMobileAgent) {
	                            this.enableTouch();
	                        } else if (this.isMobileSize) {
	                            this.enableSwipe();
	                        }
	                        this.$set('isFirstLoad', false);
	                    }
	                });
	            }
	        },
	
	        'previousHotspotIndex': function previousHotspotIndex() {
	            return this.hotspotNumber > 0 ? this.hotspotNumber - 1 : this.totalHotspots - 1;
	        },
	
	        'nextHotspotIndex': function nextHotspotIndex() {
	            return this.hotspotNumber < this.totalHotspots - 1 ? this.hotspotNumber + 1 : 0;
	        },
	
	        'nextSpot': function nextSpot() {
	            this.unbindEvents();
	            this.resetScrollPos();
	            var nextIndex = this.nextHotspotIndex();
	            var nextHotspot = this.hotspotsContent[nextIndex];
	            this.openHotspotPanel(nextHotspot, this.hotspotsContent);
	            this.bindEvents();
	
	            this.$router.go({
	                name: 'graham',
	                params: {
	                    hotspot: nextHotspot.id
	                }
	            });
	        },
	
	        'previousSpot': function previousSpot() {
	            this.unbindEvents();
	            this.resetScrollPos();
	            var previousIndex = this.previousHotspotIndex();
	            var previousHotspot = this.hotspotsContent[previousIndex];
	            this.openHotspotPanel(previousHotspot, this.hotspotsContent);
	            this.bindEvents();
	
	            this.$router.go({
	                name: 'graham',
	                params: {
	                    hotspot: previousHotspot.id
	                }
	            });
	        },
	
	        'resetScrollPos': function resetScrollPos() {
	            this.$els.scrollyMe.scrollTop = 0;
	        },
	
	        'enableSwipe': function enableSwipe() {
	            var hammertime = new _hammerjs2.default(this.$els.xrayArea, {
	                preventDefault: true
	            });
	
	            var throttleValue = 125;
	
	            hammertime.get('swipe').set({
	                direction: _hammerjs2.default.DIRECTION_HORIZONTAL
	            });
	
	            hammertime.on('swipeleft', (0, _lodash2.default)(function (ev) {
	                if (this.isMobileSize) this.nextSpot();
	            }.bind(this), throttleValue));
	
	            hammertime.on('swiperight', (0, _lodash2.default)(function (ev) {
	                if (this.isMobileSize) this.previousSpot();
	            }.bind(this), throttleValue));
	        },
	
	        'closePanel': function closePanel() {
	            var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            this.$set('isHotspotPanelVisible', false);
	            this.unbindEvents();
	            this.xrayCancelResetAnim();
	
	            setTimeout(function () {
	                this.closeHotspotPanel();
	                if (redirect) {
	                    this.$router.go({
	                        name: 'view'
	                    });
	                }
	            }.bind(this), 600);
	        },
	
	        'expandCollapseContent': function expandCollapseContent() {
	            if (this.isMobileSize) {
	                if (this.isGlobalOverlayEnabled) {
	                    this.disableGlobalOverlay();
	                } else {
	                    this.enableGlobalOverlay();
	                }
	            }
	        },
	
	        'enableTouch': function enableTouch() {
	            var hammertime = new _hammerjs2.default(this.$els.xrayArea, {
	                preventDefault: true
	            });
	
	            var throttleValue = 10;
	
	            hammertime.get('pan').set({
	                direction: _hammerjs2.default.DIRECTION_ALL,
	                threshold: 10
	            });
	
	            hammertime.on('panmove', (0, _lodash2.default)(function (event) {
	                var dX = this.xrayDeltaX + event.deltaX;
	                var dY = this.xrayDeltaY + event.deltaY;
	                var offsetTouchX = this.xrayAreaWidth / 2 + dX;
	                var offsetTouchY = this.xrayAreaHeight / 2 + dY;
	                var outsideLeft = offsetTouchX - this.xrayRadiusPx + this.xrayAreaOffsetLeft < this.xrayAreaOffsetLeft;
	                var outsideRight = offsetTouchX + this.xrayRadiusPx + this.xrayAreaOffsetLeft > this.xrayAreaOffsetLeft + this.xrayAreaWidth;
	                var outsideTop = offsetTouchY - this.xrayRadiusPx + this.xrayAreaOffsetTop < this.xrayAreaOffsetTop;
	                var outsideBottom = offsetTouchY + this.xrayRadiusPx + this.xrayAreaOffsetTop > this.xrayAreaOffsetTop + this.xrayAreaHeight;
	
	                if (outsideLeft && outsideTop) {
	                    this.$set('xrayCX', this.getCX(this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(this.xrayRadiusPx));
	                } else if (outsideRight && outsideTop) {
	                    this.$set('xrayCX', this.getCX(this.xrayAreaWidth - this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(this.xrayRadiusPx));
	                } else if (outsideLeft && outsideBottom) {
	                    this.$set('xrayCX', this.getCX(this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(this.xrayAreaHeight - this.xrayRadiusPx));
	                } else if (outsideRight && outsideBottom) {
	                    this.$set('xrayCX', this.getCX(this.xrayAreaWidth - this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(this.xrayAreaHeight - this.xrayRadiusPx));
	                } else if (outsideLeft) {
	                    this.$set('xrayCX', this.getCX(this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(offsetTouchY));
	                } else if (outsideRight) {
	                    this.$set('xrayCX', this.getCX(this.xrayAreaWidth - this.xrayRadiusPx));
	                    this.$set('xrayCY', this.getCY(offsetTouchY));
	                } else if (outsideTop) {
	                    this.$set('xrayCX', this.getCX(offsetTouchX));
	                    this.$set('xrayCY', this.getCY(this.xrayRadiusPx));
	                } else if (outsideBottom) {
	                    this.$set('xrayCX', this.getCX(offsetTouchX));
	                    this.$set('xrayCY', this.getCY(this.xrayAreaHeight - this.xrayRadiusPx));
	                } else {
	                    this.$set('xrayCX', this.getCX(offsetTouchX));
	                    this.$set('xrayCY', this.getCY(offsetTouchY));
	                }
	            }.bind(this), throttleValue));
	
	            hammertime.on('panend', (0, _lodash2.default)(function (event) {
	                this.xrayDeltaX = this.xrayDeltaX + event.deltaX;
	                this.xrayDeltaY = this.xrayDeltaY + event.deltaY;
	            }.bind(this), throttleValue));
	        }
	    },
	
	    components: {
	        'sound-component': _Sound2.default,
	        'hotspots-nav-component': _HotspotsNav2.default
	    },
	
	    ready: function ready() {
	        this.$nextTick(function () {
	            this.scrollbar = _perfectScrollbar2.default.initialize(this.$els.scrollyMe, {
	                suppressScrollX: true
	            });
	
	            setTimeout(function () {
	                this.checkMobile();
	                this.bindEvents();
	                if (this.$els.closeBt != null) this.$els.closeBt.focus();
	            }.bind(this), 1500);
	
	            this.$set('isHotspotPanelVisible', true);
	        });
	    }
	};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(15);
	
	exports.default = {
	    props: ['hotspotsContent', 'hotspotHovered'],
	
	    vuex: {
	        getters: {
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            }
	        },
	        actions: {
	            openHotspotPanel: _actions.openHotspotPanel
	        }
	    },
	
	    data: function data() {
	        return {
	            isNavbarVisible: false
	        };
	    },
	
	    ready: function ready() {
	        this.$nextTick(function () {
	            this.$set('isNavbarVisible', true);
	        });
	    },
	
	    methods: {
	        'hotspotClick': function hotspotClick(hotspotId, index) {
	            this.openHotspotDetails(hotspotId, index);
	            this.$dispatch('play-sound-once', 'hotspots-click');
	        },
	
	        'hotspotHover': function hotspotHover(hotspotId) {
	            this.$dispatch('hover-hotspot', hotspotId);
	            this.$dispatch('play-sound-once', 'hotspots-hover');
	        },
	
	        openHotspotDetails: function openHotspotDetails(hotspotId, hotspotNumber) {
	            this.$router.go({
	                name: 'graham',
	                params: {
	                    hotspot: hotspotId
	                }
	            });
	            var hotspotDetails = this.hotspotsContent.filter(function (hotspot) {
	                return hotspot.id === hotspotId;
	            })[0];
	            this.openHotspotPanel(hotspotDetails, this.hotspotsContent);
	        }
	    }
	};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _NavigationHamburger = __webpack_require__(572);
	
	var _NavigationHamburger2 = _interopRequireDefault(_NavigationHamburger);
	
	var _NavigationPanel = __webpack_require__(573);
	
	var _NavigationPanel2 = _interopRequireDefault(_NavigationPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        'navigationpanel-component': _NavigationPanel2.default,
	        'navigationhamburger-component': _NavigationHamburger2.default
	    }
	};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(15);
	
	exports.default = {
	    vuex: {
	        getters: {
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            }
	        },
	        actions: {
	            openNavMenu: _actions.openNavMenu,
	            closeNavMenu: _actions.closeNavMenu,
	            openNavMenuDelay: _actions.openNavMenuDelay,
	            closeNavMenuDelay: _actions.closeNavMenuDelay
	        }
	    },
	
	    methods: {
	        'toggleMenu': function toggleMenu() {
	            if (this.isNavMenuOpened) {
	                this.closeNavMenu();
	
	                setTimeout(function () {
	                    this.closeNavMenuDelay();
	                }.bind(this), 100);
	            } else {
	                this.openNavMenu();
	
	                setTimeout(function () {
	                    this.openNavMenuDelay();
	                }.bind(this), 400);
	            }
	        }
	    }
	};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(15);
	
	exports.default = {
	    vuex: {
	        getters: {
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            }
	        },
	        actions: {
	            closeNavMenu: _actions.closeNavMenu,
	            closeNavMenuDelay: _actions.closeNavMenuDelay
	        }
	    },
	
	    methods: {
	        closeNavPanel: function closeNavPanel() {
	            this.closeNavMenu();
	            this.closeNavMenuDelay();
	        },
	        hasRouteName: function hasRouteName(partial) {
	            return this.$route.name === partial;
	        }
	    }
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _spritz = __webpack_require__(107);
	
	var _spritz2 = _interopRequireDefault(_spritz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['isPageLoading'],
	
	    vuex: {
	        getters: {
	            isSoundSupported: function isSoundSupported(state) {
	                return state.isSoundSupported;
	            }
	        }
	    },
	
	    watch: {
	        isPageLoading: 'updateSpriteState'
	    },
	
	    data: function data() {
	        return {
	            waveSpriteLeft: false,
	            waveSpriteRight: false
	        };
	    },
	
	    ready: function ready() {
	        this.createSprite();
	    },
	
	    methods: {
	        'updateSpriteState': function updateSpriteState() {
	            if (this.waveSpriteLeft !== false && this.waveSpriteRight !== false) {
	                if (this.isPageLoading) {
	                    this.waveSpriteLeft.play(25);
	                    this.waveSpriteRight.play(25);
	                } else {
	                    this.waveSpriteLeft.pause();
	                    this.waveSpriteRight.pause();
	                }
	            }
	        },
	
	        'createSprite': function createSprite() {
	            this.waveSpriteLeft = (0, _spritz2.default)({
	                container: this.$els.waveLeft,
	                src: '/static/sprites/preloader-wave.png',
	                width: 200,
	                height: 225,
	                steps: 6,
	                rows: 3,
	                displayMode: 'fluid'
	            }).init().play(25);
	
	            this.waveSpriteRight = (0, _spritz2.default)({
	                container: this.$els.waveRight,
	                src: '/static/sprites/preloader-wave.png',
	                width: 200,
	                height: 225,
	                steps: 6,
	                rows: 3,
	                flip: true,
	                displayMode: 'fluid'
	            }).init(3).play(25);
	        }
	    }
	};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _spritz = __webpack_require__(107);
	
	var _spritz2 = _interopRequireDefault(_spritz);
	
	var _actions = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    vuex: {
	        getters: {
	            isEnvironmentSoundPlaying: function isEnvironmentSoundPlaying(state) {
	                return state.isEnvironmentSoundPlaying;
	            },
	            isFullscreenVideoOpened: function isFullscreenVideoOpened(state) {
	                return state.isFullscreenVideoOpened;
	            },
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isNavMenuOpenedDelay: function isNavMenuOpenedDelay(state) {
	                return state.isNavMenuOpenedDelay;
	            },
	            isMobileAgent: function isMobileAgent(state) {
	                return state.isMobileAgent;
	            },
	            isSoundSupported: function isSoundSupported(state) {
	                return state.isSoundSupported;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            }
	        },
	        actions: {
	            playEnvironmentSound: _actions.playEnvironmentSound,
	            stopEnvironmentSound: _actions.stopEnvironmentSound,
	            setSoundSupported: _actions.setSoundSupported
	        }
	    },
	
	    watch: {
	        'isHotspotPanelOpened': function isHotspotPanelOpened() {
	            if (this.isEnvironmentSoundPlaying && this.isSoundSupported) {
	                if (this.isHotspotPanelOpened) {
	                    this.soundEnvVolumeDown();
	                } else {
	                    this.soundEnvVolumeUp();
	                }
	            }
	        },
	        'isNavMenuOpened': function isNavMenuOpened() {
	            if (this.isEnvironmentSoundPlaying && this.isSoundSupported) {
	                if (this.isNavMenuOpened) {
	                    this.soundEnvVolumeDown();
	                } else {
	                    this.soundEnvVolumeUp();
	                }
	            }
	        },
	        'isFullscreenVideoOpened': function isFullscreenVideoOpened() {
	            if (this.isSoundSupported) {
	                if (this.isEnvironmentSoundPlaying && this.isFullscreenVideoOpened) {
	                    this.soundEnvStop();
	                } else {
	                    if (this.wasEnvironmentSoundPlaying) this.soundEnvPlay();
	                }
	            }
	        }
	    },
	
	    data: function data() {
	        return {
	            audioSpriteWhite: false,
	            audioSpriteBlack: false,
	
	            isAudioSupported: true,
	            isVolumeDown: false,
	            canPlayType: false,
	
	            soundEnvVolumeMin: 0.15,
	            soundEnvVolumeMax: 0.3,
	            soundFadeTime: 3500,
	            soundElemsVolume: 0.25,
	            wasEnvironmentSoundPlaying: true
	        };
	    },
	
	    events: {
	        'play-sound-once': function playSoundOnce(identifier) {
	            this.playOnce(identifier);
	        }
	    },
	
	    ready: function ready() {
	        this.canPlayType = typeof this.$els.audioEnv.canPlayType !== 'undefined';
	        this.spriteInit();
	        this.soundInit();
	    },
	
	    methods: {
	        'playOnce': function playOnce(identifier) {
	            if (this.isSoundSupported) {
	                var audioTarget = false;
	
	                if (identifier === 'buttons-hover') {
	                    audioTarget = this.$els.audioButtonsHover;
	                } else if (identifier === 'buttons-click') {
	                    audioTarget = this.$els.audioButtonsClick;
	                } else if (identifier === 'hotspots-hover') {
	                    audioTarget = this.$els.audioHotspotsHover;
	                } else if (identifier === 'hotspots-click') {
	                    audioTarget = this.$els.audioHotspotsClick;
	                }
	
	                if (!audioTarget.paused) {
	                    var cloneTarget = audioTarget.cloneNode(true);
	                    cloneTarget.volume = this.soundElemsVolume;
	                    cloneTarget.play();
	                } else {
	                    audioTarget.volume = this.soundElemsVolume;
	                    audioTarget.play();
	                }
	            }
	        },
	
	        'soundFade': function soundFade(to, ramp) {
	            if (this.isSoundSupported) {
	                var volume = +parseFloat(this.$els.audioEnv.volume).toFixed(2);
	                var timing = this.soundFadeTime / Math.abs(100 / (ramp * 100));
	                var final = +parseFloat(to + ramp).toFixed(2);
	
	                var fade = setInterval(function () {
	                    this.$els.audioEnv.volume = volume;
	
	                    volume = +parseFloat(volume + ramp).toFixed(2);
	
	                    if (volume === final) {
	                        clearInterval(fade);
	                    }
	                }.bind(this), timing);
	            }
	        },
	
	        'soundEnvPlay': function soundEnvPlay() {
	            if (this.$els.audioEnv.paused) {
	                this.$set('wasEnvironmentSoundPlaying', false);
	                this.soundEnvVolumeUp(false);
	                this.$els.audioEnv.play();
	                this.playEnvironmentSound();
	            } else {
	                this.$set('wasEnvironmentSoundPlaying', true);
	            }
	            this.spritePlay();
	        },
	
	        'soundEnvStop': function soundEnvStop() {
	            var manual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            if (!this.$els.audioEnv.paused) {
	                if (!manual) {
	                    this.$set('wasEnvironmentSoundPlaying', true);
	                } else {
	                    this.$set('wasEnvironmentSoundPlaying', false);
	                }
	                this.$els.audioEnv.pause();
	                this.stopEnvironmentSound();
	            } else {
	                this.$set('wasEnvironmentSoundPlaying', false);
	            }
	            this.spriteStop();
	        },
	
	        'soundEnvToggle': function soundEnvToggle() {
	            if (this.$els.audioEnv.paused) {
	                this.soundEnvPlay();
	            } else {
	                this.soundEnvStop(true);
	            }
	        },
	
	        'soundEnvVolumeToggle': function soundEnvVolumeToggle() {
	            if (this.isVolumeDown) {
	                this.soundEnvVolumeUp();
	            } else {
	                this.soundEnvVolumeDown();
	            }
	        },
	
	        'soundEnvVolumeUp': function soundEnvVolumeUp() {
	            var fade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            if (fade) this.soundFade(this.soundEnvVolumeMax, 0.05);else this.$els.audioEnv.volume = this.soundEnvVolumeMax;
	
	            this.$set('isVolumeDown', false);
	        },
	
	        'soundEnvVolumeDown': function soundEnvVolumeDown() {
	            var fade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            if (fade) this.soundFade(this.soundEnvVolumeMin, -0.05);else this.$els.audioEnv.volume = this.soundEnvVolumeMin;
	
	            this.$set('isVolumeDown', true);
	        },
	
	        'soundInit': function soundInit() {
	            if (!this.canPlayType || this.isMobileAgent) {
	                this.$set('isAudioSupported', false);
	                this.setSoundSupported(false);
	            } else {
	                this.soundEnvPlay();
	                this.$set('isAudioSupported', true);
	                this.setSoundSupported(true);
	            }
	        },
	
	        'spriteInit': function spriteInit() {
	            this.audioSpriteWhite = (0, _spritz2.default)({
	                container: this.$els.audioSpriteWhite,
	                src: '/static/sprites/audio-bars-white.png',
	                width: 70,
	                height: 20,
	                steps: 5,
	                rows: 1,
	                displayMode: 'fluid'
	            }).init();
	
	            this.audioSpriteBlack = (0, _spritz2.default)({
	                container: this.$els.audioSpriteBlack,
	                src: '/static/sprites/audio-bars-black.png',
	                width: 70,
	                height: 20,
	                steps: 5,
	                rows: 1,
	                displayMode: 'fluid'
	            }).init();
	        },
	
	        'spritePlay': function spritePlay() {
	            this.audioSpriteWhite.play(9);
	            this.audioSpriteBlack.play(9);
	        },
	
	        'spriteStop': function spriteStop() {
	            this.audioSpriteWhite.pause();
	            this.audioSpriteBlack.pause();
	        }
	    }
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(15);
	
	exports.default = {
	    vuex: {
	        getters: {
	            isGlobalOverlayEnabled: function isGlobalOverlayEnabled(state) {
	                return state.isGlobalOverlayEnabled;
	            },
	            isNavMenuOpenedDelay: function isNavMenuOpenedDelay(state) {
	                return state.isNavMenuOpenedDelay;
	            },
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            }
	        },
	        actions: {
	            disableGlobalOverlay: _actions.disableGlobalOverlay,
	            closeNavMenuDelay: _actions.closeNavMenuDelay,
	            closeNavMenu: _actions.closeNavMenu
	        }
	    },
	
	    methods: {
	        'logoClicked': function logoClicked() {
	            if (this.isNavMenuOpened) {
	                this.closeNavMenu();
	                this.closeNavMenuDelay();
	            }
	            if (this.isGlobalOverlayEnabled) this.disableGlobalOverlay();
	            if (this.$parent.$refs.hotspotPanel !== undefined && this.$parent.$refs.hotspotPanel !== null) {
	                this.$parent.$refs.hotspotPanel.closePanel(false);
	            }
	        }
	    }
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _youtubePlayer = __webpack_require__(593);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	var _actions = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    vuex: {
	        getters: {
	            youtubeVideoId: function youtubeVideoId(state) {
	                return state.youtubeVideoId;
	            },
	            useDefaultPreloader: function useDefaultPreloader(state) {
	                return state.useDefaultPreloader;
	            },
	            isMobileAgent: function isMobileAgent(state) {
	                return state.isMobileAgent;
	            },
	            isFullscreenVideoReady: function isFullscreenVideoReady(state) {
	                return state.isFullscreenVideoReady;
	            },
	            isFullscreenVideoOpened: function isFullscreenVideoOpened(state) {
	                return state.isFullscreenVideoOpened;
	            }
	        },
	        actions: {
	            setFullScreenVideoReady: _actions.setFullScreenVideoReady,
	            closeFullscreenVideo: _actions.closeFullscreenVideo
	        }
	    },
	
	    data: function data() {
	        return {
	            player: false,
	            isPlayerDisplayed: false,
	            stateNames: {
	                '-1': 'unstarted',
	                0: 'ended',
	                1: 'playing',
	                2: 'paused',
	                3: 'buffering',
	                5: 'video cued'
	            }
	        };
	    },
	
	    ready: function ready() {
	        var $this = this;
	        this.player = (0, _youtubePlayer2.default)('player', {
	            height: '390',
	            width: '640',
	            videoId: $this.youtubeVideoId,
	            playerVars: {
	                'autoplay': 1,
	                'color': 'white',
	                'showinfo': 0,
	                'controls': 1,
	                'rel': 0,
	                'disablekb': 1,
	                'iv_load_policy': 3,
	                'enablejsapi': 1,
	                'wmode': 'transparent'
	            }
	        });
	
	        this.play();
	
	        this.$nextTick(function () {
	            this.$set('isPlayerDisplayed', true);
	            this.$els.closeBt.focus();
	        });
	    },
	
	    methods: {
	        'play': function play(event) {
	            var $this = this;
	
	            if (this.useDefaultPreloader) {
	                if (!this.isMobileAgent) this.player.playVideo();
	                $this.setFullScreenVideoReady();
	            } else {
	                if (!this.isMobileAgent) this.player.playVideo();
	                this.player.on('stateChange', function (event) {
	                    if ($this.stateNames[event.data] === 'playing') {
	                        $this.setFullScreenVideoReady();
	                    }
	                });
	            }
	        },
	
	        'stop': function stop() {
	            this.player.stopVideo();
	        },
	
	        'closeVideo': function closeVideo() {
	            this.stop();
	            this.closeFullscreenVideo();
	            this.$set('isPlayerDisplayed', false);
	            this.$set('player', false);
	        }
	    }
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(148);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Navigation = __webpack_require__(571);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(568);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Towards = __webpack_require__(575);
	
	var _Towards2 = _interopRequireDefault(_Towards);
	
	var _Preloader = __webpack_require__(574);
	
	var _Preloader2 = _interopRequireDefault(_Preloader);
	
	var _YoutubeVideo = __webpack_require__(576);
	
	var _YoutubeVideo2 = _interopRequireDefault(_YoutubeVideo);
	
	var _HotspotPanel = __webpack_require__(569);
	
	var _HotspotPanel2 = _interopRequireDefault(_HotspotPanel);
	
	var _actions = __webpack_require__(15);
	
	var _lodash = __webpack_require__(84);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    store: _store2.default,
	
	    vuex: {
	        getters: {
	            isGlobalOverlayEnabled: function isGlobalOverlayEnabled(state) {
	                return state.isGlobalOverlayEnabled;
	            },
	            isFullscreenVideoOpened: function isFullscreenVideoOpened(state) {
	                return state.isFullscreenVideoOpened;
	            },
	            isHotspotPanelOpened: function isHotspotPanelOpened(state) {
	                return state.isHotspotPanelOpened;
	            },
	            isMobileAgent: function isMobileAgent(state) {
	                return state.isMobileAgent;
	            },
	            isMobileSize: function isMobileSize(state) {
	                return state.isMobileSize;
	            },
	            isBrowserIE: function isBrowserIE(state) {
	                return state.isBrowserIE;
	            },
	            isBrowserSafari: function isBrowserSafari(state) {
	                return state.isBrowserSafari;
	            },
	            isNavMenuOpened: function isNavMenuOpened(state) {
	                return state.isNavMenuOpened;
	            },
	            isSoundSupported: function isSoundSupported(state) {
	                return state.isSoundSupported;
	            }
	        },
	        actions: {
	            closeHotspotPanel: _actions.closeHotspotPanel,
	            closeFullscreenVideo: _actions.closeFullscreenVideo,
	            setMobileAgent: _actions.setMobileAgent,
	            setMobileSize: _actions.setMobileSize,
	            setBrowserIE: _actions.setBrowserIE,
	            setBrowserSafari: _actions.setBrowserSafari
	        }
	    },
	
	    data: function data() {
	        return {
	            template: __webpack_require__(504),
	            isPageLoading: true,
	            isDarkTemplate: false,
	            isFirstLoading: true,
	            startDelay: false,
	            mobileBreakpointX: 1024,
	            mobileBreakpointY: 640
	        };
	    },
	
	    events: {
	        'viewport-bind': function viewportBind(routeName) {
	            this.$nextTick(function () {
	                this.$broadcast('viewport-bind', routeName);
	            });
	        },
	        'viewport-unbind': function viewportUnbind(routeName) {
	            this.$broadcast('viewport-unbind', routeName);
	        },
	        'loading-start': function loadingStart() {
	            this.$set('isPageLoading', true);
	
	            if (this.isHotspotPanelOpened) this.closeHotspotPanel();
	            if (this.isFullscreenVideoOpened) this.closeFullscreenVideo();
	        },
	        'loading-end': function loadingEnd() {
	            window.requestAnimationFrame(this.delayPreloader);
	
	            if (window.phantom) {
	                setTimeout(function () {
	                    var event = document.createEvent('CustomEvent');
	                    event.initCustomEvent('prerender-ready', true, true, {});
	                    window.dispatchEvent(event);
	                }, 3000);
	            }
	        },
	        'play-sound-once': function playSoundOnce(identifier) {
	            this.$broadcast('play-sound-once', identifier);
	        }
	    },
	
	    created: function created() {
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
	            this.setMobileAgent(true);
	        } else {
	            this.setMobileAgent(false);
	        }
	
	        this.calcIfMobileSize();
	        window.addEventListener('resize', (0, _lodash2.default)(function () {
	            this.calcIfMobileSize();
	        }.bind(this), 500));
	
	        var ua = window.navigator.userAgent;
	        var msie = ua.indexOf('MSIE ');
	        var isIE = msie > 0 || !!ua.match(/Trident.*rv:11\./);
	        this.setBrowserIE(isIE);
	
	        var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
	        this.setBrowserSafari(isSafari);
	    },
	
	    methods: {
	        'delayPreloader': function delayPreloader(timestamp) {
	            if (!this.startDelay) this.startDelay = timestamp;
	
	            var progress = timestamp - this.startDelay;
	
	            if (progress < 500) {
	                window.requestAnimationFrame(this.delayPreloader);
	            } else {
	                this.$set('isPageLoading', false);
	                this.$set('isFirstLoading', false);
	            }
	        },
	        'calcIfMobileSize': function calcIfMobileSize() {
	            if (window.innerWidth < this.mobileBreakpointX || window.innerHeight < this.mobileBreakpointY) {
	                this.setMobileSize(true);
	            } else {
	                this.setMobileSize(false);
	            }
	        }
	    },
	
	    components: {
	        'navigation-component': _Navigation2.default,
	        'footer-component': _Footer2.default,
	        'towards-component': _Towards2.default,
	        'preloader-component': _Preloader2.default,
	        'youtube-video-component': _YoutubeVideo2.default,
	        'hotspot-panel-component': _HotspotPanel2.default
	    }
	};

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

	module.exports = {"meta_title":"Meet Graham","meta_description":"As much as we like to think we’re invincible, we’re not. But what if our bodies were to change to cope with the impact of a car accident?","sharing_url":"http://www.meetgraham.com.au","sharing_safe_url":"http://www.meetgraham.com.au","sharing_title":"Meet Graham","sharing_description":"As much as we like to think we’re invincible, we’re not. But what if our bodies were to change to cope with the impact of a car accident? Meet Graham at www.meetgraham.com.au","sharing_twitter_site":"@TACVictoria","sharing_twitter":"This is how I might need to look to survive an accident on our roads","sharing_image":"/static/social/meet-graham_1200x630.jpg","sharing_image_type":"image/jpeg","sharing_image_width":"1200","sharing_image_height":"630","sharing_hashtag":"meetgraham"}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlZJREFUeNrcmuuRgjAQxxOGAihBO8AK1A7s4EgJV8FpBdqBXgXeVYBXAXSgHWgH3C63OJwS5JGQhP/Mjl945Ocm+wjxmQJlWRbAzwJsDhaSBZLLb2Ap2A/9njjnN2ZSALACO2b9hc9YmQCIwM6ZeuEzoyEAFpoAqoAWOgACsG02vLYqISZgSWZOCQWTWnkvIDD6JBSFTAnffaaxtAehG+OaMDqkcAxxHYwnm04WQTzCBI1A6MKjZRD/YJp65MPwmni5ZqqiGX/MEzJiC7WE0uYk88ieuaNt5dSi0mDiEEhYLmd4CeTsGAjqAtNrevcIVZ6uQaAmRdVcTK035q7ysXuUN/r2AjMw0eE+Qff20d0jKsrlEObqoSWMoHt65yycXj61p321h4cxHBj+Ngjjgq6NFIX8EGlihSV3VOog+1zTVjE+8Kq4f6gbqA6IvKNkmpqhqgHrgsjlawqJj2uGKV4TT/I1xvc7TKkE0lbLeWwk0umRcohtE5qtAnnKEy3zTKesOJrwO5qEuB4QQhfMuthRHxJCB8yKUxl/VVDGhx0WsaBvJEmfl3MU/StHBT2JKR0AQxQJ8dPhXPg9vs0H0sZBb2xkO40ueSUFb8xkRaNwyBvv0uqX9lJ3DkDsyvu+T1OrNMVMf6VqPKVe9SNL9vdh3zbdaGzNGis6iWAbTD4m2SkJrybtpxbBFBBpp1aXbpxSPWRsTeAY6iAa9ezoSlpcJqIZRqeZ8kM3dIRjiMMDiZYjHBVAbh+qqdoFt+WYE1cJRUl0TvWarGa7kP1QcvtS8f5fAQYAEZ8YEWZRC3MAAAAASUVORK5CYII="

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNDM2LjYgMTQzNi42IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNDM2LjYgMTQzNi42OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03MTguMywwQzMyMS42LDAsMCwzMjEuNiwwLDcxOC4zczMyMS42LDcxOC4zLDcxOC4zLDcxOC4zczcxOC4zLTMyMS42LDcxOC4zLTcxOC4zCglDMTQzNi41LDMyMS42LDExMTUsMCw3MTguMywweiBNOTQyLjksOTQzLjRjLTUuOCw1LjgtMTMsOC40LTIwLjcsOC40Yy03LjgsMC0xNC45LTIuNi0yMC43LTguNEw3MTcuOSw3NTkuOUw1MzQuNCw5NDMuNAoJYy01LjgsNS44LTEzLDguNC0yMC43LDguNHMtMTQuOS0yLjYtMjAuNy04LjRjLTExLjctMTEuNy0xMS43LTI5LjgsMC00MS41bDE4My41LTE4My41TDQ5Myw1MzVjLTExLjctMTEuNy0xMS43LTI5LjgsMC00MS41CglzMjkuOC0xMS43LDQxLjUsMEw3MTcuOSw2NzdsMTgzLjUtMTgzLjVjMTEuNy0xMS43LDI5LjgtMTEuNyw0MS41LDBjMTEsMTEuNywxMSwyOS44LDAsNDEuNUw3NTkuNCw3MTguNUw5NDIuOSw5MDIKCUM5NTQuNiw5MTMuNiw5NTQuNiw5MzEuNyw5NDIuOSw5NDMuNHoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.e5b990a.png";

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkM1MTExNEEzQzQxMTFFNjkxRUFBQkZDNDc5MDZCNjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjgzMEFFMjYzQzQ1MTFFNjkxRUFBQkZDNDc5MDZCNjciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGQzUxMTE0ODNDNDExMUU2OTFFQUFCRkM0NzkwNkI2NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGQzUxMTE0OTNDNDExMUU2OTFFQUFCRkM0NzkwNkI2NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuQp+bAAAAIESURBVHja7JbNK0RhFMbnCol8i8yMEpFkY8WGBeWjkTSlrO1sLcQ/ILZSyGKWREjISiTKimwkX7sRiSaRj1HX89a5ebzMuBdDyanfvOc+57xz7r3v1zVM03T9tMW5fsH+VNF4MAyWQNGbqBrTGFBtvlgI5HDcyZNOgBGbucfgUvx0sPaZJ52lO4+PkpdFfpn52vqtmJ2CM9QxGKGo0qbALRgi3a8V9tgpOqN1ilQ0Wcvrpdgi6aMfFZ0131owyuvt0XJLRS8g7Q4kGvgpxNA2AoOG2gda3pkgp0Dlh2VZ+MEOOJT4HGgTfwG0ir8C6sRvUXdyYNo39aSGPMG8aI+gWLQ08ET52aJ3kTaglozb4cK3NussaRNAQPxrsEy5tdLuklamioY+sdsoawcX4tcAj/jrlFtCw2JZ+Ve2wTOwRdfWdndFWqq0D6Tlf6VoLqii6xNpM0m7kzaFtHNVNMNhsSdpp6Wwsk0Q1MZR2ZG0XtL24rT3bcespXVDWie9zmbSV6WtJG1fTYoG0PTOOvVFmUhhWaMdYBscSCxAE22RJlob9d/4zh2pO8KO5CHtASQ5OV2iFU3R8vooNkX6+HefMnMgDMZIr9duxmu3qEv+0M556iZfbfT31G/QyXlqMWkdTTbIk7di2T7HY/WNVKdNHu9PFE2USbMKKvS48f+FH0t7FmAAWukPnA6iwYEAAAAASUVORK5CYII="

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	module.exports = " <footer class=\"footer gr-container\" role=contentinfo v-bind:class=\"{ '-menu-opened' : isNavMenuOpenedDelay }\"> <div class=\"row row-full\"> <div class=\"gr-2@medium gr-3@large no-gutter-left hide show@large\"> <sound-component v-el:sound></sound-component> </div> <div class=\"gr-12 gr-10@medium gr-9@large no-gutter-right _text-right@medium footer-links\" v-bind:class=\"{ '-menu-is-open' : isNavMenuOpenedDelay }\"> <ul> <li v-if=isNavMenuOpenedDelay> <a v-on:click.stop=closeNavPanel() v-link=\"{ name: 'privacy' }\">Privacy policy</a> </li> <li v-if=isNavMenuOpenedDelay> <a href=https://www.tac.vic.gov.au/about-the-tac/contact-us rel=nofollow target=_blank>Contact</a> </li> <li v-if=isNavMenuOpenedDelay class=hide-on-mobile> <a v-on:click=closeNavPanel() v-link=\"{ name: 'accessibility' }\">Accessibility</a> </li> <li v-if=isNavMenuOpenedDelay class=hide-on-mobile> <a v-on:click=closeNavPanel() v-link=\"{ name: 'disclaimer' }\">Disclaimer</a> </li> <li> Share <a v-el:facebook-share href=#share-on-facebook title=\"Share on Facebook\" class=facebook-share rel=nofollow v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'true' : 'false' ]\" v-bind:tabindex=\"[ isHotspotPanelOpened ? '-1' : '0' ]\"> <i v-if=!isNavMenuOpenedDelay class=\"facebook-white@22 size@19\"></i> <i v-if=isNavMenuOpenedDelay class=\"facebook-black@22 size@19\"></i> </a> <a v-el:twitter-share href=#share-on-twitter title=\"Share on Twitter\" rel=nofollow class=twitter-share v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'true' : 'false' ]\" v-bind:tabindex=\"[ isHotspotPanelOpened ? '-1' : '0' ]\"> <i v-if=!isNavMenuOpenedDelay class=twitter-white@22></i> <i v-if=isNavMenuOpenedDelay class=twitter-black@22></i> </a> </li> </ul> </div> </div> </footer> ";

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

	module.exports = " <div class=hotspot-panel v-bind:class=\"{ 'active' : isHotspotPanelVisible }\"> <button class=back-to-360 tabindex=0 v-el:close-bt v-on:click=closePanel aria-label=\"Close and back to the threesixty view\"> <div class=cross></div> </button> <div class=\"row row-full\"> <div class=\"no-gutter hotspot-imagery\"> <div class=hotspot-xray-area v-el:xray-area v-bind:style=\"{ backgroundImage: 'url(' + hotspot.image + ')' }\"> <div class=mobile-overlay></div> <svg class=xray> <defs> <clipPath id=\"clipping-{{ hotspot.id }}\"> <circle class=xray-ellipse id=\"ellipse-{{ hotspot.id }}\" v-el:xray-ellipse v-bind:cx=\"this.xrayCX + '%'\" v-bind:cy=\"this.xrayCY + '%'\" v-bind:r=\"this.xrayRadius + '%'\"> <animate class=animate-reset-cx v-el:xray-cx-reset-anim attributeName=cx begin=indefinite dur=.5s fill=freeze to=50% /> <animate class=animate-reset-cy v-el:xray-cy-reset-anim attributeName=cy begin=indefinite dur=.5s fill=freeze to=50% /> </circle> </clipPath> </defs> </svg> <svg> <use xlink:href=\"#ellipse-{{ hotspot.id }}\"/> <image xlink:href=\"{{ hotspot.imageXray }}\" x=0 y=0 width=100% height=100% preserveAspectRatio=\"xMidYMid slice\" v-bind:style=\"{ clipPath: 'url(#clipping-' + hotspot.id + ')' }\" v-on:click=expandCollapseContent /> </svg> </div> <button class=previous-hotspot v-on:click.prevent=previousSpot()><i class=chevron-left-white@22></i></button> <button class=next-hotspot v-on:click.prevent=nextSpot()><i class=chevron-right-white@22></i></button> <div class=hotspot-mobile-line> <ul class=hotspot-mobile-line-dots> <li> <span class=hotspot-number>{{ this.previousHotspotIndex() + 1 | addZero }}</span> </li> <li> <span class=hotspot-number>{{ hotspotNumber + 1 | addZero }}</span> <span class=hotspot-title>{{ hotspot.name }}</span> </li> <li> <span class=hotspot-number>{{ this.nextHotspotIndex() + 1 | addZero }}</span> </li> </ul> </div> </div> <div class=\"gr-6@large gr-5@xlarge gr-4@xxlarge no-gutter hotspot-content\" v-bind:class=\"{ 'expanded' : isGlobalOverlayEnabled }\" v-if=hotspot> <button class=\"mobile-button expand-collapse-bt\" v-on:click=expandCollapseContent> Learn about his {{ hotspot.name }} <span class=icon><i class=\"arrow-up-black@22 size@16\"></i></span> </button> <span class=label> {{ hotspotNumber + 1 | addZero }} / {{ totalHotspots | addZero }} </span> <h1 class=\"_h2 title\" role=heading>{{ hotspot.title }}</h1> <div class=scrolly-me-container v-el:scrolly-me> <div class=scrolly-me> <div class=markdown v-if=hotspot.content> {{{ hotspot.content | markdown }}} </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	module.exports = " <div class=navigation-menu> <navigationhamburger-component></navigationhamburger-component> <navigationpanel-component></navigationpanel-component> </div> ";

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	module.exports = " <button v-on:click.stop=toggleMenu class=navigation-hamburger v-bind:class=\"{ '-open': isNavMenuOpened, '-close': !isNavMenuOpened }\" aria-label=menu aria-controls=menu v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'true' : 'false' ]\" v-bind:tabindex=\"[ isHotspotPanelOpened ? '-1' : '0' ]\" v-bind:aria-expanded=\"[ isNavMenuOpened ? 'true' : 'false'  ]\"> <div class=container> <div class=circle></div> <div class=bar-wrap> <div class=\"bar bar1\"></div> <div class=\"bar bar2\"></div> <div class=\"bar bar3\"></div> </div> <div class=cross-wrap> <div class=\"cross-line cross-line1\"></div> <div class=\"cross-line cross-line2\"></div> </div> </div> </button> ";

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

	module.exports = " <div class=navigation-panel> <nav role=menu id=menu class=items> <ul> <li> <a v-on:click=closeNavPanel() v-link=\"{ name: 'view' }\" role=menuitem v-bind:aria-hidden=\"[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]\" v-bind:tabindex=\"[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]\"> View<span class=hide-for-mobile> Graham</span> </a> </li> <li> <a v-on:click=closeNavPanel() v-link=\"{ name: 'about' }\" role=menuitem v-bind:aria-hidden=\"[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]\" v-bind:tabindex=\"[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]\"> About<span class=hide-for-mobile> the project</span> </a> </li> <li> <a v-on:click=closeNavPanel() v-link=\"{ name: 'context' }\" role=menuitem v-bind:aria-hidden=\"[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]\" v-bind:tabindex=\"[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]\"> <span class=hide-for-mobile>The Broader </span>Context </a> </li> <li> <a v-on:click=closeNavPanel() v-link=\"{ name: 'educational' }\" role=menuitem v-bind:aria-hidden=\"[ isNavMenuOpened && !isHotspotPanelOpened ? 'false' : 'true'  ]\" v-bind:tabindex=\"[ isNavMenuOpened && !isHotspotPanelOpened ? '0' : '-1'  ]\"> Education<span class=hide-for-mobile>al Experience</span> </a> </li> </ul> </nav> </div> ";

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=preloader> <div class=wrapper> <div class=ring v-bind:class=\"{ '-paused': !isPageLoading }\"> <div class=wave-left v-el:wave-left></div> <div class=speaker> <img src=" + __webpack_require__(545) + " data-fallback-src=" + __webpack_require__(544) + " alt=\"Turn your sound up\"> </div> <div class=wave-right v-el:wave-right></div> </div> <div class=text v-if=isSoundSupported>Turn your sound up for the best experience</div> <div class=text v-else>Loading in progress</div> </div> <div class=backoverlay></div> </div> ";

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	module.exports = " <div> <div v-if=isAudioSupported> Sound <button v-on:click=soundEnvToggle tabindex=0 aria-label=\"Play or Pause Environment Sound\" v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'true' : 'false' ]\" v-bind:tabindex=\"[ isHotspotPanelOpened ? '-1' : '0' ]\" v-bind:aria-disabled=\"[ isEnvironmentSoundPlaying ? 'false' : 'true' ]\"> <i v-if=!isNavMenuOpenedDelay class=\"volume-white@22 size@19\"></i> <i v-if=isNavMenuOpenedDelay class=\"volume-black@22 size@19\"></i> <span v-show=!isNavMenuOpenedDelay class=audio-sprite v-el:audio-sprite-white></span> <span v-show=isNavMenuOpenedDelay class=audio-sprite v-el:audio-sprite-black></span> </button> <audio v-el:audio-env loop aria-label=\"Environment Sound\"> <source src=/static/sound/environment.mp3 type=audio/mpeg> </audio> <audio v-el:audio-buttons-hover preload aria-label=\"Buttons Hover Sound\"> <source src=/static/sound/buttons-hover.mp3 type=audio/mpeg> </audio> <audio v-el:audio-buttons-click preload aria-label=\"Buttons Click Sound\"> <source src=/static/sound/buttons-click.mp3 type=audio/mpeg> </audio> <audio v-el:audio-hotspots-hover preload aria-label=\"Hotspots Hover Sound\"> <source src=/static/sound/hotspots-hover.mp3 type=audio/mpeg> </audio> <audio v-el:audio-hotspots-click preload aria-label=\"Hotspots Click Sound\"> <source src=/static/sound/hotspots-click.mp3 type=audio/mpeg> </audio> </div> </div> ";

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=towards-zero v-bind:class=\"{ '-menu-opened' : isNavMenuOpenedDelay }\"> <div class=project-title> <a v-link=\"{ name: 'home' }\" v-on:click=logoClicked tabindex=0 aria-label=\"Back to Project Graham Homepage\"> <div class=svg-container-logo> <img class=logo src=" + __webpack_require__(541) + " alt=\"Project Graham Logo\"> </div> </a> </div> </div> ";

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=youtube-video-container v-bind:class=\"{ 'ready' : isPlayerDisplayed }\"> <button class=close-video tabindex=0 v-el:close-bt v-on:click.stop.prevent=closeVideo v-on:touchstart.stop.prevent=closeVideo aria-label=\"Close Fullscreen Video\"> <img src=" + __webpack_require__(535) + " data-fallback-src=" + __webpack_require__(534) + " alt=\"Close Fullscreen Video\"> </button> <div id=player class=youtube-video v-bind:class=\"{ '-default-preloader' : useDefaultPreloader }\"></div> </div> ";

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

	module.exports = " <div class=v-app v-bind:class=\"{ 'v-loading': isPageLoading, 'v-loading-first': isFirstLoading, '-dark': isDarkTemplate, 'navigation-opened': isNavMenuOpened, '-global-overlay': isGlobalOverlayEnabled }\"> <preloader-component :is-page-loading=isPageLoading v-bind:aria-hidden=\"[ isPageLoading ? 'false' : 'true'  ]\"></preloader-component> <towards-component></towards-component> <youtube-video-component v-if=isFullscreenVideoOpened v-bind:aria-hidden=\"[ isFullscreenVideoOpened ? 'false' : 'true'  ]\"></youtube-video-component> <hotspot-panel-component v-ref:hotspot-panel v-if=isHotspotPanelOpened v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'false' : 'true'  ]\"></hotspot-panel-component> <navigation-component></navigation-component> <router-view v-el:router-view v-view-directive v-bind:route-name=$route.name class=v-router-view keep-alive :is-dark-template.sync=isDarkTemplate v-bind:aria-hidden=\"[ isHotspotPanelOpened ? 'true' : 'false'  ]\"></router-view> <footer-component v-el:footer></footer-component> </div> ";

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

	module.exports = " <ul class=hotspots-nav _v-65b23038=\"\"> <li role=button v-bind:aria-label=hotspot.name v-bind:tabindex=\"[ isNavMenuOpened || isHotspotPanelOpened ? '-1' : '0'  ]\" v-bind:aria-hidden=\"[ isNavMenuOpened || isHotspotPanelOpened ? 'true' : 'false'  ]\" v-for=\"hotspot in hotspotsContent\" v-on:mouseenter=hotspotHover(hotspot.id) v-on:focus=hotspotHover(hotspot.id) v-on:mouseleave=\"this.$dispatch('unhover-hotspot')\" v-on:blur=\"this.$dispatch('unhover-hotspot')\" v-on:click=\"hotspotClick(hotspot.id, $index)\" v-bind:class=\"{ 'visible' : isNavbarVisible, 'hover' : hotspotHovered === hotspot.id }\" v-on:keyup.enter=\"hotspotClick(hotspot.id, $index)\" _v-65b23038=\"\"> <div class=hotspot-nav-item _v-65b23038=\"\"> <div _v-65b23038=\"\"> <span class=number _v-65b23038=\"\">{{ $index + 1 | addZero }}</span> <span class=title _v-65b23038=\"\">{{ hotspot.name }}</span> </div> </div> </li> </ul> ";

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(484)
	__vue_script__ = __webpack_require__(212)
	__vue_template__ = __webpack_require__(547)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(485)
	__vue_script__ = __webpack_require__(213)
	__vue_template__ = __webpack_require__(548)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(486)
	__vue_script__ = __webpack_require__(216)
	__vue_template__ = __webpack_require__(549)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(487)
	__vue_script__ = __webpack_require__(217)
	__vue_template__ = __webpack_require__(550)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(488)
	__vue_script__ = __webpack_require__(218)
	__vue_template__ = __webpack_require__(551)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(489)
	__vue_script__ = __webpack_require__(219)
	__vue_template__ = __webpack_require__(552)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(491)
	__vue_script__ = __webpack_require__(221)
	__vue_template__ = __webpack_require__(554)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(492)
	__vue_script__ = __webpack_require__(222)
	__vue_template__ = __webpack_require__(555)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(495)
	__vue_script__ = __webpack_require__(225)
	__vue_template__ = __webpack_require__(558)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })

});


// WEBPACK FOOTER //
// static/js/app.aae35eeb31118d3b9e1b.js